import { IUserDepricated } from "@mctypes/global.types";
import React from "react";
import { Avatar } from "../../../../../components";

const IssueTableUserCellRenderer: React.FC<{ user: IUserDepricated }> = ({ user }) => {
  return user != null ? (
    <div className="d-flex align-items-center">
      <Avatar id={user._id} name={user.name} />
      <div className="ml-2">{user.name}</div>
    </div>
  ) : (
    <div />
  );
};

export default IssueTableUserCellRenderer;
